<template>
    <div class="scan-container">
      <div class="scan">
        <div class="fingerprint"></div>
        <h3>Scansionando..</h3>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Scanning'
  }
  </script>
  
  <style scoped>
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: consolas;
  }
  .scan-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .scan {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .scan .fingerprint {
    position: relative;
    width: 300px;
    height: 240px;
    background: url('@/assets/images/altri/fingerprint.png');
    background-repeat: no-repeat;
    background-size: 300px;
  }
  
  .scan .fingerprint::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('@/assets/images/altri/fingerprint_3.png');
    background-repeat: no-repeat;
    background-size: 300px;
    animation: animate 4s ease-in-out infinite;
  }
  @keyframes animate {
    0%,100% {
      height: 0%;
    }50% {
      height: 100%;
    }
  }
  .scan .fingerprint::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width:100%;
    height: 8px;
    background: #14F20C;
    border-radius: 8px;
    filter: drop-shadow(0 0 20px #14F20C) drop-shadow(0 0 60px #14F20C);
    animation: animate_line 4s ease-in-out infinite;
  }
  @keyframes animate_line{
    0%,100% {
      top: 0%;
    }50% {
      top: 100%;
    }
  }
  .scan h3 {
    text-transform: uppercase;
    font-size: 2em;
    letter-spacing: 2px;
    margin-top: 20px;
    color: #14F20C;
    filter: drop-shadow(0 0 20px #14F20C) drop-shadow(0 0 60px #14F20C);
    animation: animate_text 1s steps(1) infinite;
  }
  
  @keyframes animate_text {
    0%,100% {
      opacity: 0;
    }50% {
      opacity: 1;
    }
  }
  </style>
  